package com.downdogapp.client

import com.downdogapp.*
import kotlin.js.Date

actual fun currentClockTime() = millis(Date().getTime())
